import React, { useEffect } from 'react';
import { useTourSearchStore } from '../../store/TourSearchStore';
import TourSearchResults from './TourSearchResults';
import { useLocation } from 'react-router-dom';
export default function TourSearchResultsContainer({ hideHeader = false, forceDocumentNavigation = false, newTourSearch = false, suppressInitialSpinner = false, hideWhileLoading = false, onSearchResultReady, forceSearchKey = 0, forceSearchQuery }) {
    const [_, actions] = useTourSearchStore();
    const { search } = useLocation();
    useEffect(() => {
        if (newTourSearch)
            actions.searchNewTourURLParams(search);
        else
            actions.searchURLParams(search);
    }, [search, newTourSearch]);
    useEffect(() => {
        if (!forceSearchKey)
            return;
        const query = forceSearchQuery !== null && forceSearchQuery !== void 0 ? forceSearchQuery : search;
        if (newTourSearch)
            actions.searchNewTourURLParams(query, true);
        else
            actions.searchURLParams(query, true);
    }, [forceSearchKey, forceSearchQuery, newTourSearch]);
    return React.createElement(TourSearchResults, { hideHeader: hideHeader, forceDocumentNavigation: forceDocumentNavigation, suppressInitialSpinner: suppressInitialSpinner, hideWhileLoading: hideWhileLoading, onSearchResultReady: onSearchResultReady });
}
